import { Breakpoints } from "utilities/enumerations/breakpoints";
import useBreakpointRange from "utilities/hooks/use-breakpoint-range";
import useBreakpoint, { BreakpointComparer } from "./use-breakpoint";

const useBreakpointRanges = () => {
    const isUnableToSupportAllBookviewPanels = useBreakpointRange(
        Breakpoints.Phone,
        Breakpoints.Desktop
    );

    const inMobileView = useBreakpoint(
        Breakpoints.Phone,
        BreakpointComparer.MaxWidth
    );

    return {
        isUnableToSupportAllBookviewPanels,
        inMobileView,
    };
};

export default useBreakpointRanges;
